var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var DataExportService = /** @class */ (function (_super) {
    __extends(DataExportService, _super);
    function DataExportService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 工单导出
     */
    DataExportService.prototype.exportWorkOrder = function (data, loading) {
        return this.netService.send({
            server: dataimpService.dataExportController.exportWorkOrder,
            data: data,
            loading: loading,
        });
    };
    /**
     * 案件导出
     */
    DataExportService.prototype.exportCase = function (data, loading) {
        return this.netService.send({
            server: dataimpService.dataExportController.exportCase,
            data: data,
            loading: loading,
        });
    };
    /**
     * 调记导出
     */
    DataExportService.prototype.exportFollowRecord = function (data, loading) {
        return this.netService.send({
            server: dataimpService.dataExportController.exportFollowRecord,
            data: data,
            loading: loading,
        });
    };
    /**
     * 联系人导出
     */
    DataExportService.prototype.exportContact = function (data, loading) {
        return this.netService.send({
            server: dataimpService.dataExportController.exportContact,
            data: data,
            loading: loading,
        });
    };
    /**
     * 分案导出
     */
    DataExportService.prototype.exportDistribute = function (data, loading) {
        return this.netService.send({
            server: dataimpService.dataExportController.exportDistribute,
            data: data,
            loading: loading,
        });
    };
    __decorate([
        Inject(NetService)
    ], DataExportService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], DataExportService.prototype, "exportWorkOrder", null);
    __decorate([
        Debounce()
    ], DataExportService.prototype, "exportCase", null);
    __decorate([
        Debounce()
    ], DataExportService.prototype, "exportFollowRecord", null);
    __decorate([
        Debounce()
    ], DataExportService.prototype, "exportContact", null);
    __decorate([
        Debounce()
    ], DataExportService.prototype, "exportDistribute", null);
    return DataExportService;
}(Service));
export { DataExportService };
